(() => {

// Parcel entrypoint for incremental, non-legacy enhancements.
const $185ee067a0fab524$var$modal = document.querySelector("[data-medical-modal]");
const $185ee067a0fab524$var$openButtons = document.querySelectorAll("[data-medical-modal-open]");
const $185ee067a0fab524$var$closeButtons = document.querySelectorAll("[data-medical-modal-close]");
const $185ee067a0fab524$var$elapsedTimerControllers = [];
const $185ee067a0fab524$var$syncBodyModalLock = ()=>{
    const hasOpenModal = Boolean(document.querySelector(".seh-modal.is-open, .seh-confirm-modal.is-open"));
    document.body.classList.toggle("seh-modal-open", hasOpenModal);
};
if ($185ee067a0fab524$var$modal && $185ee067a0fab524$var$openButtons.length > 0) {
    const setModalState = (isOpen)=>{
        $185ee067a0fab524$var$modal.classList.toggle("is-open", isOpen);
        $185ee067a0fab524$var$modal.setAttribute("aria-hidden", isOpen ? "false" : "true");
        $185ee067a0fab524$var$syncBodyModalLock();
    };
    $185ee067a0fab524$var$openButtons.forEach((button)=>{
        button.addEventListener("click", ()=>setModalState(true));
    });
    $185ee067a0fab524$var$closeButtons.forEach((button)=>{
        button.addEventListener("click", ()=>setModalState(false));
    });
    document.addEventListener("keydown", (event)=>{
        if (event.key === "Escape" && $185ee067a0fab524$var$modal.classList.contains("is-open")) setModalState(false);
    });
}
const $185ee067a0fab524$var$elapsedTimers = document.querySelectorAll("[data-elapsed-timer]");
const $185ee067a0fab524$var$emergencyMedicationModal = document.querySelector("[data-emergency-medication-modal]");
const $185ee067a0fab524$var$call112Modal = document.querySelector("[data-call-112-modal]");
const $185ee067a0fab524$var$call112CloseButtons = document.querySelectorAll("[data-call-112-close]");
const $185ee067a0fab524$var$emergencyMedicationCloseButtons = document.querySelectorAll("[data-emergency-medication-close]");
const $185ee067a0fab524$var$emergencyMedicationCheckbox = document.getElementById("emergency-medication-checkbox");
const $185ee067a0fab524$var$emergencyMedicationNotQualifiedCheckbox = document.getElementById("emergency-medication-not-qualified-checkbox");
const $185ee067a0fab524$var$emergencyMedicationCanAdministerGroup = document.querySelector(".seh-confirm-modal__can-administered");
const $185ee067a0fab524$var$emergencyMedicationConfirmButton = document.querySelector("[data-emergency-medication-confirm]");
const $185ee067a0fab524$var$emergencyMedicationNotAdministeredButton = document.querySelector("[data-emergency-medication-not-administered]");
const $185ee067a0fab524$var$emergencyMedicationStepGroup = document.querySelector(".emergency-medication-step-group");
const $185ee067a0fab524$var$setEmergencyMedicationModalState = (isOpen)=>{
    if (!$185ee067a0fab524$var$emergencyMedicationModal) return;
    $185ee067a0fab524$var$emergencyMedicationModal.classList.toggle("is-open", isOpen);
    $185ee067a0fab524$var$emergencyMedicationModal.setAttribute("aria-hidden", isOpen ? "false" : "true");
    $185ee067a0fab524$var$syncBodyModalLock();
};
const $185ee067a0fab524$var$setCall112ModalState = (isOpen)=>{
    if (!$185ee067a0fab524$var$call112Modal) return;
    $185ee067a0fab524$var$call112Modal.classList.toggle("is-open", isOpen);
    $185ee067a0fab524$var$call112Modal.setAttribute("aria-hidden", isOpen ? "false" : "true");
    $185ee067a0fab524$var$syncBodyModalLock();
};
if ($185ee067a0fab524$var$elapsedTimers.length > 0) $185ee067a0fab524$var$elapsedTimers.forEach((timer)=>{
    const valueEl = timer.querySelector("[data-elapsed-value]");
    if (!valueEl) return;
    let elapsed = Number.parseInt(timer.getAttribute("data-start-seconds") || "0", 10);
    const thresholdMinutes = Number.parseInt(timer.getAttribute("data-emergency-medication-minutes") || "0", 10);
    const call112ThresholdMinutes = Number.parseInt(timer.getAttribute("data-call-112-minutes") || "0", 10);
    const thresholdSeconds = Number.isNaN(thresholdMinutes) ? 0 : Math.max(thresholdMinutes, 0) * 60;
    const call112ThresholdSeconds = Number.isNaN(call112ThresholdMinutes) ? 0 : Math.max(call112ThresholdMinutes, 0) * 60;
    let emergencyMedicationShown = false;
    let call112Shown = false;
    if (Number.isNaN(elapsed) || elapsed < 0) elapsed = 0;
    const renderElapsed = ()=>{
        const minutes = Math.floor(elapsed / 60);
        const seconds = elapsed % 60;
        valueEl.textContent = `${minutes}:${String(seconds).padStart(2, "0")}`;
        if ($185ee067a0fab524$var$emergencyMedicationModal && !emergencyMedicationShown && thresholdSeconds > 0 && elapsed >= thresholdSeconds) {
            emergencyMedicationShown = true;
            $185ee067a0fab524$var$setEmergencyMedicationModalState(true);
        }
        if ($185ee067a0fab524$var$call112Modal && !call112Shown && call112ThresholdSeconds > 0 && elapsed >= call112ThresholdSeconds) {
            call112Shown = true;
            $185ee067a0fab524$var$setCall112ModalState(true);
        }
    };
    renderElapsed();
    const intervalId = window.setInterval(()=>{
        elapsed += 1;
        renderElapsed();
    }, 1000);
    $185ee067a0fab524$var$elapsedTimerControllers.push(()=>window.clearInterval(intervalId));
});
// WooCommerce pa_type-abonnement variation selector (product page).
// Uses jQuery because WooCommerce variation JS only listens for jQuery events.
const $185ee067a0fab524$var$typeSelect = document.getElementById("type_abonnement_select");
if ($185ee067a0fab524$var$typeSelect && window.jQuery) {
    const $ = window.jQuery;
    $($185ee067a0fab524$var$typeSelect).on("change", function() {
        const val = $(this).val();
        $("#pa_type-abonnement").val(val).trigger("change");
    });
}
const $185ee067a0fab524$var$thumbnailSlider = document.querySelector(".media-thumbnail-slider");
if ($185ee067a0fab524$var$thumbnailSlider && window.jQuery) {
    const $ = window.jQuery;
    const imageBaseName = (url)=>(url || "").split("?")[0].split("/").pop().replace(/\.[^.]+$/, "").replace(/-\d+x\d+$/, "").replace(/-scaled$/, "").toLowerCase();
    const findVariationThumbnail = (variation)=>{
        const thumbnails = Array.from($185ee067a0fab524$var$thumbnailSlider.querySelectorAll(".media-thumbnail"));
        const byId = thumbnails.find((thumbnail)=>thumbnail.dataset.attachmentId === String(variation.image_id));
        if (byId) return byId;
        const variationName = imageBaseName(variation.image && variation.image.full_src);
        if (!variationName) return null;
        return thumbnails.find((thumbnail)=>{
            const img = thumbnail.querySelector("img");
            return img && imageBaseName(img.getAttribute("src")) === variationName;
        });
    };
    $(".single_variation_wrap").on("show_variation", (event, variation)=>{
        const thumbnail = findVariationThumbnail(variation);
        if (thumbnail) $($185ee067a0fab524$var$thumbnailSlider).slick("slickGoTo", Number(thumbnail.dataset.num));
    });
}
const $185ee067a0fab524$var$endAttackModal = document.querySelector("[data-end-attack-modal]");
const $185ee067a0fab524$var$endAttackOpenButtons = document.querySelectorAll("[data-end-attack-open]");
const $185ee067a0fab524$var$endAttackCloseButtons = document.querySelectorAll("[data-end-attack-close]");
const $185ee067a0fab524$var$endAttackConfirmButtons = document.querySelectorAll("[data-end-attack-confirm]");
if ($185ee067a0fab524$var$endAttackModal && $185ee067a0fab524$var$endAttackOpenButtons.length > 0) {
    const setEndAttackModalState = (isOpen)=>{
        $185ee067a0fab524$var$endAttackModal.classList.toggle("is-open", isOpen);
        $185ee067a0fab524$var$endAttackModal.setAttribute("aria-hidden", isOpen ? "false" : "true");
        $185ee067a0fab524$var$syncBodyModalLock();
    };
    $185ee067a0fab524$var$endAttackOpenButtons.forEach((button)=>{
        button.addEventListener("click", ()=>setEndAttackModalState(true));
    });
    $185ee067a0fab524$var$endAttackCloseButtons.forEach((button)=>{
        button.addEventListener("click", ()=>setEndAttackModalState(false));
    });
    $185ee067a0fab524$var$endAttackConfirmButtons.forEach((button)=>{
        button.addEventListener("click", ()=>{
            $185ee067a0fab524$var$elapsedTimerControllers.forEach((stopTimer)=>stopTimer());
            setEndAttackModalState(false);
        });
    });
    document.addEventListener("keydown", (event)=>{
        if (event.key === "Escape" && $185ee067a0fab524$var$endAttackModal.classList.contains("is-open")) setEndAttackModalState(false);
        if (event.key === "Escape" && $185ee067a0fab524$var$emergencyMedicationModal && $185ee067a0fab524$var$emergencyMedicationModal.classList.contains("is-open")) $185ee067a0fab524$var$setEmergencyMedicationModalState(false);
    });
}
if ($185ee067a0fab524$var$emergencyMedicationModal && $185ee067a0fab524$var$emergencyMedicationCloseButtons.length > 0) $185ee067a0fab524$var$emergencyMedicationCloseButtons.forEach((button)=>{
    button.addEventListener("click", ()=>$185ee067a0fab524$var$setEmergencyMedicationModalState(false));
});
if ($185ee067a0fab524$var$call112Modal && $185ee067a0fab524$var$call112CloseButtons.length > 0) $185ee067a0fab524$var$call112CloseButtons.forEach((button)=>{
    button.addEventListener("click", ()=>$185ee067a0fab524$var$setCall112ModalState(false));
});
if ($185ee067a0fab524$var$emergencyMedicationCheckbox && $185ee067a0fab524$var$emergencyMedicationNotQualifiedCheckbox && $185ee067a0fab524$var$emergencyMedicationConfirmButton) {
    const syncEmergencyMedicationConfirm = ()=>{
        const canAdminister = $185ee067a0fab524$var$emergencyMedicationCheckbox.checked;
        const notQualified = $185ee067a0fab524$var$emergencyMedicationNotQualifiedCheckbox.checked;
        $185ee067a0fab524$var$emergencyMedicationConfirmButton.disabled = !canAdminister;
        $185ee067a0fab524$var$emergencyMedicationConfirmButton.classList.toggle("is-hidden", notQualified);
        $185ee067a0fab524$var$emergencyMedicationConfirmButton.setAttribute("aria-hidden", notQualified ? "true" : "false");
        if ($185ee067a0fab524$var$emergencyMedicationCanAdministerGroup) {
            $185ee067a0fab524$var$emergencyMedicationCanAdministerGroup.hidden = notQualified;
            $185ee067a0fab524$var$emergencyMedicationCanAdministerGroup.setAttribute("aria-hidden", notQualified ? "true" : "false");
        }
        if ($185ee067a0fab524$var$emergencyMedicationNotAdministeredButton) {
            $185ee067a0fab524$var$emergencyMedicationNotAdministeredButton.classList.toggle("is-visible", notQualified);
            $185ee067a0fab524$var$emergencyMedicationNotAdministeredButton.setAttribute("aria-hidden", notQualified ? "false" : "true");
        }
        if ($185ee067a0fab524$var$emergencyMedicationStepGroup) {
            $185ee067a0fab524$var$emergencyMedicationStepGroup.classList.toggle("is-visible", canAdminister);
            $185ee067a0fab524$var$emergencyMedicationStepGroup.setAttribute("aria-hidden", canAdminister ? "false" : "true");
        }
    };
    syncEmergencyMedicationConfirm();
    $185ee067a0fab524$var$emergencyMedicationCheckbox.addEventListener("change", ()=>{
        if ($185ee067a0fab524$var$emergencyMedicationCheckbox.checked) $185ee067a0fab524$var$emergencyMedicationNotQualifiedCheckbox.checked = false;
        syncEmergencyMedicationConfirm();
    });
    $185ee067a0fab524$var$emergencyMedicationNotQualifiedCheckbox.addEventListener("change", ()=>{
        if ($185ee067a0fab524$var$emergencyMedicationNotQualifiedCheckbox.checked) $185ee067a0fab524$var$emergencyMedicationCheckbox.checked = false;
        syncEmergencyMedicationConfirm();
    });
}
if ($185ee067a0fab524$var$emergencyMedicationNotAdministeredButton) $185ee067a0fab524$var$emergencyMedicationNotAdministeredButton.addEventListener("click", ()=>{
    window.location.href = "tel:112";
});
document.addEventListener("keydown", (event)=>{
    if (event.key === "Escape" && $185ee067a0fab524$var$call112Modal && $185ee067a0fab524$var$call112Modal.classList.contains("is-open")) $185ee067a0fab524$var$setCall112ModalState(false);
});

})();
//# sourceMappingURL=app.js.map
